export class AddProfile {
    constructor(
        public firstName: string,
        public lastName: string,
        public email: string,
        public password: string,
        public password2: string
    ) {}
}


// WEBPACK FOOTER //
// C:/Magento2/gs-kiosk/src/app/routes/addprofile/addprofile.ts